import { render, staticRenderFns } from "./RelatedInventoryRequests.vue?vue&type=template&id=50b439c3&"
import script from "./RelatedInventoryRequests.vue?vue&type=script&lang=js&"
export * from "./RelatedInventoryRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports